if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        } else {
          console.warn('No input found with name="id[]".');
        }
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onFormSuccess(){
        console.log('on form success');
        
        if (document.querySelector('.upsells-popup')) {
          console.log('.upsells-popup exists!');
          const upsellsPopup = document.querySelector('.upsells-popup');
          
          const buttons = this.form.querySelectorAll('button');
          const addToCart = this.form.querySelectorAll('button .add-to-cart');
          const addedToCart = this.form.querySelectorAll('button .added-to-cart');

          if (buttons.length > 0 && addToCart.length > 0 && addedToCart.length > 0) {
              buttons.forEach((button, index) => {
                  const addToCartElement = addToCart[index];
                  const addedToCartElement = addedToCart[index];

                  if (addToCartElement && addedToCartElement) {
                      addToCartElement.style.display = 'none';
                      addedToCartElement.style.display = 'block';
                      button.disabled = true;
                  }
              });
          }
          upsellsPopup.classList.add('active');
        } else {
          console.log('.upsells-popup does not exist.');
           window.location = window.routes.cart_url;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('should submit now')
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.onFormSuccess();
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const deliveryData = document.querySelector('.deliveryData');
        const formNotifyButton = document.querySelector('.gw-button-widget');

        if (disable) {
          console.log('disable:', disable);
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.style.display = 'none';
          if (text) this.submitButtonText.textContent = text;
          if (deliveryData) deliveryData.style.display = 'none';
          
        } else {
          this.submitButton.style.display = 'block';
          if (deliveryData) deliveryData.style.display = 'inline-block';
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id[]"]');
      }
    }
  );
}

document.querySelectorAll('.upsell-checkbox').forEach(checkbox => {
  checkbox.addEventListener('change', function() {
    const productType = checkbox.getAttribute('data-product-type');
    const relatedSelect = document.querySelector(`.upsell-select[data-product-type="${productType}"]`);
    
    if (relatedSelect) {
      if (checkbox.checked) {
        relatedSelect.setAttribute('name', 'id[]');
      } else {
        relatedSelect.removeAttribute('name');
      }
    }
  });
});




document.addEventListener('DOMContentLoaded', function() {
    function updatePurchaseAmount() {
        const sellingPriceElement = document.getElementById('totalPrice');
        let sellingPrice = sellingPriceElement.innerText.trim();

        // Remove euro symbol and spaces
        sellingPrice = sellingPrice.replace('€', '').trim();

        // Remove thousands separator (dot) and replace comma with dot for decimal
        sellingPrice = sellingPrice.replace('.', ''); // Remove thousands separator
        sellingPrice = sellingPrice.replace(',', '.'); // Replace decimal comma with dot

        // Convert to a valid number in cents
        const purchaseAmount = Math.round(parseFloat(sellingPrice) * 100); // Klarna expects the amount in cents

        // Ensure the result is a valid number
        if (isNaN(purchaseAmount)) {
            console.error('Invalid purchase amount calculated:', sellingPrice);
            return;
        }

        const klarnaPlacement = document.querySelector('klarna-placement');
        klarnaPlacement.setAttribute('data-purchase-amount', purchaseAmount);
    }

    updatePurchaseAmount();
    setInterval(updatePurchaseAmount, 0); 
});








  document.addEventListener('DOMContentLoaded', function() {
    const outOfStock = document.querySelector('.not-available-holder');
    const klarnaElement = document.querySelector('klarna-placement, #klarna-osm-container'); // Adjust this selector

    if (outOfStock && klarnaElement) {
      klarnaElement.style.display = 'none'; // Hide Klarna if "Esgotado" is present
    }
  });





